module.exports = __webpack_public_path__ + "img/unsupported.d3013e63.svg";